import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-weather-icon',
  templateUrl: './weather-icon.component.html',
  styleUrls: ['./weather-icon.component.css']
})
export class WeatherIconComponent {
  @Input() type: 'sun' | 'cloud' | 'rain' | 'storm' | 'partly-cloudy' = 'sun';
  @Input() size: number = 100;
}
